export const getTeam = (data, valueKey = '') => {
  const mapping = {};
  const items = [];
  data.forEach((v) => {
    const id = v.team_id;
    const name = v.team_name;
    const parent = v.parent_id;
    if (!mapping[id]) {
      mapping[id] = {};
    }
    mapping[id].value = v[valueKey] || id;
    mapping[id].desc = name;

    if (!parent) {
      items.push(mapping[id]);
    } else {
      mapping[id].parent_id = parent;
      if (!mapping[parent]) {
        mapping[parent] = {};
      }
      if (!mapping[parent].options) {
        mapping[parent].options = [];
      }
      mapping[parent].options.push(mapping[id]);
    }
  });

  const withoutChilren = {};
  Object.keys(mapping).forEach((v) => {
    const { value, desc, parent_id: parentId } = mapping[v];
    withoutChilren[v] = { value, desc };
    if (parentId) {
      withoutChilren[v].parent_id = parentId;
    }
  });

  return { map: withoutChilren, items };
};
